import { render, staticRenderFns } from "./TextWithIconButton.vue?vue&type=template&id=62861b2a"
import script from "./TextWithIconButton.vue?vue&type=script&lang=js"
export * from "./TextWithIconButton.vue?vue&type=script&lang=js"
import style0 from "./TextWithIconButton.vue?vue&type=style&index=0&id=62861b2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports